// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel } from './authenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AuthenticationSaveCurrentUserSaveCurrentUserRequestModel {
    'userName': string;
    'firstName': string;
    'lastName': string;
    'phone': AuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel | null;
    'fax': AuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel | null;
    'email': AuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AuthenticationSaveCurrentUserSaveCurrentUserRequestModel>> = [
        {
            "name":     "userName",
            "baseName": "userName",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "AuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "AuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "AuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel"
        },
    ];

    static getAttributeTypeMap() {
        return AuthenticationSaveCurrentUserSaveCurrentUserRequestModel.attributeTypeMap;
    }
}
